import { ICustomFieldResSchema } from '@monetize/types/app';
import { MText } from '../../../../components/Monetize';
import { createColumnHelper } from '../../../../components/Monetize/DataTableNew/appTable';
import { UsagePropertyColumnHeader } from './UsagePropertyColumnHeader';
import { UsagePropertyRecord } from './usageProperties.utils';

export const USAGE_PROPERTY_COLUMN_SIZE = 200;
export const USAGE_PROPERTY_COLUMN_MIN_SIZE = 160;

/**
 * One display column per `properties.<key>` for a usage events table. Keys
 * should come from `mergePropertyColumnKeys` so configured fields lead and
 * data-only keys still render.
 *
 * `getProperties` says where the map lives on a row; the default suits rows
 * that are the usage event itself, and the import error table passes its own
 * because it wraps each event alongside a failure reason.
 */
export function getUsagePropertyColumns<TData extends object>(
  columnHelper: ReturnType<typeof createColumnHelper<TData>>,
  propertyKeys: string[],
  customFieldsByKey: Record<string, ICustomFieldResSchema>,
  getProperties: (row: TData) => Record<string, string> | null | undefined = (
    row,
  ) => (row as UsagePropertyRecord).properties,
) {
  return propertyKeys.map((key) =>
    columnHelper.display({
      id: `properties.${key}`,
      header: () => (
        <UsagePropertyColumnHeader
          propertyKey={key}
          field={customFieldsByKey[key]}
        />
      ),
      size: USAGE_PROPERTY_COLUMN_SIZE,
      minSize: USAGE_PROPERTY_COLUMN_MIN_SIZE,
      enableSorting: false,
      cell: ({ row }) => (
        <MText>{getProperties(row.original)?.[key] ?? ''}</MText>
      ),
    }),
  );
}
